import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { statusColorMapping } from "../../../enums";
import { getCurrentDate } from "../../../../../utils/helpers";
import { Box } from "@mui/material";
import { IconCell } from "../../../../core-ui/IconCell";

export const columns = [
  {
    title: 'Număr comandă',
    field: 'orderNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Număr aviz',
    field: 'noticeNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Magazin',
    field: 'shopCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Furnizor',
    field: 'supplierName',
    align: 'left',
    render: row => `${row.supplierName} (${row?.supplierCode})`,
    type: 'string'
  },
  {
    title: 'Status',
    field: 'dsDeliveryStatus',
    align: 'left',
    type: 'string',
    render: row => (
      <div style={{ color: statusColorMapping[row.dsDeliveryStatus] || 'black' }}>{row.dsDeliveryStatusValue}</div>
    )
  },
  {
    title: 'Status comandă',
    field: 'orderStatus',
    align: 'left',
    type: 'string',
    render: row => `${row.orderStatusDescription} (${row?.orderStatus})`,
    width: '200px'
  },
  {
    title: 'Raion',
    field: 'rayonName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data comenzii',
    field: 'orderDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Conformitate temperatura',
    field: 'temperatureComplaint',
    align: 'left',
    type: 'string',
    width: '130px',
    render: row => (
      <Box>
        <IconCell value={row.temperatureComplaint ? 'activ' : 'inactiv'} />
      </Box>
    )
  },
  {
    title: 'Temperatura',
    field: 'arrivalTemperature',
    align: 'left',
    render: row => row.arrivalTemperature ? `${row.arrivalTemperature}` : '',
    type: 'string'
  }
]

const currentDate = getCurrentDate()

export const drawerFilters = (shopCodes, statusOptions) => [
  {
    name: 'orderNumber',
    filter: <Input variant="outlined" label="Număr comandă" type="text" />,
    type: 'text',
    label: 'Număr comandă'
  },
  {
    name: 'shopCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        disableClearable
        options={shopCodes || []}
      />
    ),
    type: 'autocomplete',
    label: 'Magazin'
  },
  {
    name: 'supplierCode',
    value: '',
    filter: <Input variant="outlined" label="Cod furnizor" type="number" />,
    type: 'number',
    label: 'Cod furnizor'
  },
  {
    name: 'dsDeliveryStatus',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Status"
        disableClearable
        options={statusOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Status'
  },
  {
    name: 'rayonName',
    value: '',
    filter: <Input variant="outlined" label="Nume Raion" type="text" />,
    type: 'text',
    label: 'Nume Raion'
  },
  {
    name: 'rayonCode',
    value: '',
    filter: <Input variant="outlined" label="Cod Raion" type="number" />,
    type: 'number',
    label: 'Cod Raion'
  },
  {
    name: 'startOrderDate',
    value: currentDate,
    filter: (
      <DatePicker
        label="Selecteaza data de la"
        variant="outlined"
        value={currentDate}
        onChange={() => {}}
        required
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data de la'
  },
  {
    name: 'endOrderDate',
    value: currentDate,
    filter: (
      <DatePicker
        label="Selecteaza data pana la"
        variant="outlined"
        value={currentDate}
        onChange={() => {}}
        required
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data pana la'
  },
  {
    name: 'temperatureComplaint',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează conformitate temperatura"
        disableClearable
        options={[
          { label: 'Da', value: 'true' },
          { label: 'Nu', value: 'false' }
        ]}
      />
    ),
    type: 'autocomplete',
    label: 'Conformitate temperatura'
  },
]
